// Menu toggle

const menuBtn = document.querySelector('[data-mobile-open]');
const target = document.querySelector('[data-mobile-nav]');
const logo = document.querySelector('.topbar__logo');

const toggleClass = 'topbar__nav--show';
const activeClass = 'is-active';
const logoClass = 'topbar__logo--navlayer';

const getFocusableElements = () => {
    return [...document.querySelectorAll(
            '[data-mobile-nav] a[href], [data-mobile-open]'
        )
    ];
};

const closeNav = () => {
    target.classList.remove(toggleClass);
    target.removeAttribute('role');
    target.removeAttribute('aria-modal');
    menuBtn.classList.remove(activeClass);
    menuBtn.setAttribute('aria-expanded', 'false');
    logo.classList.remove(logoClass);

    menuBtn.focus();

    document.removeEventListener('keydown', menuKeyListener);
}

const openNav = () => {
    target.classList.add(toggleClass);
    target.setAttribute('role', 'dialog');
    target.setAttribute('aria-modal', 'true');
    menuBtn.classList.add(activeClass);
    menuBtn.setAttribute('aria-expanded', 'true');
    logo.classList.add(logoClass);

    const focusableElements = getFocusableElements();

    if (focusableElements.length) {
        focusableElements[0].focus();
    }

    document.addEventListener('keydown', menuKeyListener);
};

function toggleMenu(event) {
    event.preventDefault();
    if (target.classList.contains(toggleClass)) {
        closeNav();
    } else {
        openNav();
    }
}

const menuKeyListener = (event) => {
    if (event.key === "Escape") {
        closeNav();
    }

    if (event.key !== 'Tab') {
        return;
    }

    const focusableElements = getFocusableElements();

    if (!focusableElements.length) {
        return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
    }
};

if (menuBtn) {
    menuBtn.addEventListener('click', toggleMenu, false);
}
